// url for searching stories ordered by the newest to oldest

export const TIME_BASED_STORY_SEARCH_URL = 'https://hn.algolia.com/api/v1/search_by_date?tags=story'


// url for searching based on query given by the user and popularity

export const QUERY_BASED_SEARCH_URL_BY_POPULARITY = 'https://hn.algolia.com/api/v1/search?query='

// url for searching based on query given by the user and date

export const QUERY_BASED_SEARCH_URL_BY_DATE = 'https://hn.algolia.com/api/v1/search_by_date?query='